import * as Sentry from '@sentry/browser';

interface AxiosError {
  response: {
    status: number;
    data: unknown;
  };
}

const sendReport = (error: AxiosError, payload = '', token = '') => {
  if (error?.response) {
    let data = '',
      status = '';
    if (error.response.data) {
      data = JSON.stringify(error.response.data);
    }
    if (error.response.status) {
      status = JSON.stringify(error.response.status);
    }
    if (Number(status) >= 500) {
      Sentry.configureScope((scope) => {
        scope.setExtra('response_data', data);
        scope.setExtra('response_status', status);
        scope.setExtra('payload', payload);
        scope.setExtra('token', token);
      });
      Sentry.captureException(error);
    }
  }
};

export default sendReport;
